module.exports = __webpack_public_path__ + "static/img/contant_5.1dc4d50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_4/contant_5.jpg
// module id = L26K
// module chunks = 0